var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayDark = function SvgPlayDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    width: 57,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 26.804c4 2.31 4 8.083 0 10.392L9.646 62.804c-4 2.31-9-.577-9-5.196V6.392c0-4.619 5-7.505 9-5.196z",
    fill: "#252533"
  })));
};
export { SvgPlayDark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjY0IiB2aWV3Qm94PSIwIDAgNTcgNjQiIHdpZHRoPSI1NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0ibTU0IDI2LjgwMzhjNCAyLjMwOTQgNCA4LjA4MjkgMCAxMC4zOTIzbC00NC4zNTM4MyAyNS42MDc3Yy00IDIuMzA5NC04Ljk5OTk5OC0uNTc3My04Ljk5OTk5Ny01LjE5NjFsLjAwMDAwMi01MS4yMTU0YzAtNC42MTg4IDUuMDAwMDA1LTcuNTA1NTUgOS4wMDAwMDUtNS4xOTYxNXoiCiAgICAgICAgZmlsbD0iIzI1MjUzMyIgLz4KPC9zdmc+Cg==";